// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCurrency from '../../../../shared/components/labeled-currency';

const LaborValue = props =>
    <section className='labor-value'>
        <LabeledCurrency
            className='claim-value-header'
            data={props.laborTotal}
            label='LABOR'
        />
        <LabeledCurrency
            data={props.laborValue}
            label='VALUE'
        />
        <LabeledCurrency
            data={props.laborAdditive}
            label='ADDITIVE'
        />
    </section>;

LaborValue.displayName = 'LaborValue';
LaborValue.propTypes = {
    laborAdditive: PropTypes.number,
    laborTotal: PropTypes.number,
    laborValue: PropTypes.number
};

export default LaborValue;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-value/labor-value.js